import { Button, Modal } from "react-bootstrap";
import "./payment.modal.scss";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { CircularProgress } from "@mui/material";
import { faClose, faWarning } from "@fortawesome/free-solid-svg-icons";
import IMAGE_PAYMENT from "../assets/images/payment.png";
import { trackEvent } from "../utils/trackGA4.util";
import { GAConfig } from "../utils/ga-config.util";
import UtilityService from "../utils/ga4.util";
interface paymentProps {
    isOpen: boolean
    onClose(): void
}

const PaymentModal: React.FC<paymentProps> = ({ isOpen, onClose }) => {


    const clickPay = () => {
        trackEvent(GAConfig.action.payment, UtilityService());
    }

    return (
        <>
            <Modal show={isOpen} onHide={onClose} backdrop="static" centered>

                <Modal.Body>
                    <div className="payment-control">
                        <FontAwesomeIcon icon={faClose} onClick={onClose} className="close-icon" />
                        <div className="payment-content">

                            <img src={IMAGE_PAYMENT} alt="payment" className="payment-image" />
                            <span className="payment-description">เรากำลังพัฒนาให้คุณสามารถชำระเงินได้อย่างสะดวกและปลอดภัย ผ่านระบบที่เชื่อถือได้
                                กรุณารอติดตามการอัปเดตเร็ว ๆ นี้ เพื่อประสบการณ์การใช้งานที่ดียิ่งขึ้น</span>
                                <Button className="button-std payment-button" onClick={clickPay}>ชำระเงิน</Button>
                        </div>


                    </div>
                </Modal.Body>

            </Modal>
        </>
    )
}

export default PaymentModal;